import { InjectionToken } from '@angular/core';

export interface IAppConfiguration {
  baseApiUrl: string;
  licenseUrl: string;
}

export const APP_CONFIG = new InjectionToken<IAppConfiguration>('app.config');

export const AC_PIPLINE_LOGGING_ENABLED = new InjectionToken<boolean>('ac.logging.enabled');

export const signalRDiagnosticClientKey = 'signalRDiagnosticClient';
export const signalRLoggingEnabledKey = 'signalRLoggingEnabled';
export const signalRSessionIdKey = 'signalRLoggingSessionId';

export const msalLoggingEnabledKey = 'msalLoggingEnabled';
export const msalLoggingSessionEnabledKey = 'msalLoggingSessionId';

export const acPipelionLoggingEnabledKey = 'acPipelineLoggingEnabled';

export const AC_PIPELINE_LOG_NAME = 'ac-pipeline';
